import fePerms from "@/common/permissions/sale/fePerms"
import React from "react"
import PropTypes from "prop-types"
import { Button, Tabs, TabPanel, Table, Column } from "@tencent/spaui"
import { withApi } from "@tencent/react-aio"
import { withRouter } from "react-router-dom"
import CreateActionRecordModal from "./CreateActionRecordModal"
import Delegate from "@/components/Delegate"
import _ from "lodash"
import UserInfo from "@/business-components/sale/UserInfo"
import ProgressStatus from "@/components/ProgressStatus"
import { getMessage } from "@/utils/MessageUtils"
import WithPermission from "@/common/permissions/WithPermission"
import perms from "@/common/permissions/sale/perms"
import DateTime from "@/components/DateTime"
import ActionRecordDescription from "./ActionRecordDescription"
import LinkButton from "@/components/LinkButton"
import ChangePotentialStatusModal from "./ChangePotentialStatusModal"
import { isContain } from "@/utils/ParamUtils"
import { connect } from "react-redux"
import MessageBox from "@/components/MessageBox"
import AudioBar from "@/business-components/sale/audio/AudioBar"
import ActivityList from "../ActivityList"
import ReceiveRecordPanel from "./ReceiveRecord"
import ModifyLog from "../ModifyLog"
import PotentialCopyModal from "./PotentialCopyModal"
import CleanLeadModal from "../CleanLeadModal"
import ReleaseLeadModal from "../ReleaseLeadModal"
import { ACTIVITY_UPDATE_REMIND, CALL_CENTER_VENDOR, cleanLeadPerms, PROGRESS_STATUS } from "@/constants/Constants"
import { getQuery } from "@/utils"
import { refreshStatisticOnDetail } from "@/business-components/sale/FollowUp/util";

const btnStyle = { marginRight: "10px" }
class ActionRecordPanel extends React.PureComponent {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    loginStatus: PropTypes.object.isRequired,
    lead: PropTypes.object.isRequired,
    potential: PropTypes.object,
    order: PropTypes.object,
    readOnly: PropTypes.bool,
    onChange: PropTypes.func,
    onRef: PropTypes.func,
    isLead: PropTypes.bool,
  }

  state = {
    tabVal: "record",
    activityData: {},
    ModifyLogData: {},
    loading: false,
  }

  constructor(props) {
    super(props)
    this.createActionRecordModal = React.createRef()
    this.changePotentialStatusModal = React.createRef()
    this.audioModal = React.createRef()
    this.potentialCopyModal = React.createRef()
    this.clearLeadModal = React.createRef()
    this.releaseLeadModal = React.createRef()
    // 记录第一次切换活动tab
    this.firstView = true
  }

  componentDidMount() {
    this.fetchActionRecordList('打开页面')
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.lead !== prevState?.lead) {
      // 不同 lead 需要重新拉 record
      this.fetchActionRecord();
    }
  }

  fetchActionRecord() {
    this.setState({
      lead: this.props.lead,
    });
    const {
      webApi,
      lead: { leadId },
    } = this.props;
    const agencyId = getQuery('agencyId');
    webApi
      .getActionRecordList(leadId, agencyId)
      .ajax()
      .then(
        (resp) => {
          this.processActionRecords(resp);
        },
        (error) => {
          this.context.error('获取行动记录失败', error.message);
        },
      );
  }

  fetchActionRecordList(actionName) {
    this.fetchActionRecord();
    // 操作时触发
    actionName && refreshStatisticOnDetail({ data: this.props.isLead ? this.props.lead : this.props.potential, actionName });
  }

  processActionRecords(resp) {
    const { lead } = this.props
    let actionRecordList = resp
    // 非自建线索，把(最早一条)创建记录作为创建 + 下发类型，多一次线索下发的展示，两条记录内容一样
    if (lead && lead.systemSourceType !== "SYSTEM_SOURCE_TYPE_AGENCY_CREATED") {
      let firstCreated = _(actionRecordList)
        .filter((record) => record.actionType === "ACTION_TYPE_CREATE_LEAD")
        .sort((record) => record.actionTime)
        .head()

      if (firstCreated) {
        let dispatch = Object.assign({}, firstCreated)
        dispatch.actionType = "ACTION_TYPE_DISPATCH"
        dispatch.oldOwnerId = undefined
        actionRecordList = _.concat(actionRecordList, dispatch)
      }
    }

    this.setState({
      actionRecordList: _.sortBy(actionRecordList, ["actionTime"]),
    })
  }

  handleChange = (e, tabVal) => {
    this.setState({
      tabVal,
    })
    const { tabVal: oldTabVal } = this.state
    const {
      lead: { activityIsRemind },
    } = this.props
    if (tabVal === "activity" && oldTabVal !== "activity") {
      this.fetchActivityListData()
      this.activityList.initPage()
      if (activityIsRemind === ACTIVITY_UPDATE_REMIND.remind && this.firstView) {
        this.updateActivityRemind()
      }
    }
    if (tabVal === "modifylog" && oldTabVal !== "modifylog") {
      this.fetchModifyLogData()
      this.modifyLog.initPage()
    }
  }

  fetchActivityListData = (page = {}) => {
    const {
      webApi,
      lead: { leadId },
    } = this.props
    const { pageSize = 20, pageIndex = 0 } = page
    this.setState({ loading: true })
    webApi
      .activitySearchList(leadId, pageSize, pageIndex)
      .ajax()
      .then(
        (res) => {
          if (res) {
            this.setState({
              activityData: res,
              loading: false,
            })
          }
        },
        (error) => {
          this.context.error("获取活动列表失败", error.message)
          this.setState({ loading: false, activityData: {} })
        }
      )
  }

  /**
   * @description: 更新活动提醒状态
   */
  updateActivityRemind = () => {
    const {
      webApi,
      lead: { leadId },
    } = this.props
    const params = {
      activityIsRemind: 0,
      leadId,
    }
    webApi
      .updateActivityRemind()
      .ajaxJson({
        data: params,
      })
      .then(
        (res) => {
          this.firstView = false
        },
        (err) => {
          console.log(err)
        }
      )
  }

  /**
   * @description: 批注标红显示
   */
  renderComment = (actionRecord, component) => {
    const style = actionRecord.actionType === "ACTION_TYPE_ADD_ANNOTATION" ? { color: "red" } : {}
    return <div style={style}>{component}</div>
  }

  /**
   * @description: 请求日志列表
   * @param {*} page
   * @return {*}
   */
  fetchModifyLogData = (page = {}) => {
    const {
      webApi,
      lead: { leadId },
    } = this.props
    const { pageSize = 20, pageIndex = 0 } = page
    const params = {
      leadId,
      pageSize,
      pageIndex,
    }
    this.setState({ loading: true })
    webApi
      .searchLog()
      .ajax({
        data: params,
      })
      .then(
        (res) => {
          if (res) {
            this.setState({
              ModifyLogData: res,
              loading: false,
            })
          }
        },
        (error) => {
          this.context.error("获取日志失败", error.message)
          this.setState({ loading: false, ModifyLogData: {} })
        }
      )
  }

  /**
   * @description: 清洗线索
   */
  showClearLeadModal = (data) => {
    const { cleanReasonConfig, onChange } = this.props
    this.clearLeadModal.current.show({
      leadId: data.leadId,
      version: data.version,
      companyName: data.company.companyName,
      onSubmit: () => {
        onChange && onChange()
        this.fetchActionRecordList('清洗线索')
      },
      reasonList: cleanReasonConfig.isOpenStateTag ? cleanReasonConfig.reasonList : {},
      isOpenStateTag: cleanReasonConfig.isOpenStateTag,
    })
  }

  /**
   * @description: 释放
   */
  showReleaseLeadModal = (data) => {
    const { onChange } = this.props
    this.releaseLeadModal.current.show({
      leadList: [data],
      callback: () => {
        onChange && onChange()
        this.fetchActionRecordList('释放')
      },
    })
  }

  render() {
    const { readOnly, loginStatus, lead, version, permissions, potential, isLead } = this.props
    const { actionRecordList, tabVal, activityData, ModifyLogData, loading } = this.state

    // 对行动记录进行过滤、分组
    // let groups = _.groupBy(
    //   _.reject(
    //     actionRecordList,
    //     (record) =>
    //       // 不展示非自己的申领记录
    //       record.actionType === "ACTION_TYPE_OBTAIN" && record.actionHandlerId !== loginStatus.userId
    //     // // 不展示呼出电话，且客户振铃时长为 0
    //     // || (record.actionType === 'ACTION_TYPE_DIAL_OUT' && record.customerAlertDuration === 0)
    //     // // 不展示呼入电话，且销售振铃时长为 0
    //     // || (record.actionType === 'ACTION_TYPE_DIAL_IN' && record.seatAlertDuration === 0)
    //   ),
    //   (record) => record.oldProgressStatus
    // )
    const _actionRecordList = _.reverse(_.reject(
      actionRecordList,
      (record) =>
        // 不展示非自己的申领记录
        (record.actionType === "ACTION_TYPE_OBTAIN" && record.actionHandlerId !== loginStatus.userId) || !_.includes(Object.keys(PROGRESS_STATUS), record.oldProgressStatus)
      // // 不展示呼出电话，且客户振铃时长为 0
      // || (record.actionType === 'ACTION_TYPE_DIAL_OUT' && record.customerAlertDuration === 0)
      // // 不展示呼入电话，且销售振铃时长为 0
      // || (record.actionType === 'ACTION_TYPE_DIAL_IN' && record.seatAlertDuration === 0)
    ))

    // 获取外部导入的跟进记录
    // const externalImportRecordList = _.map(groups['PROGRESS_STATUS_LEAD'], record => {
    //   if (record.actionType === 'ACTION_TYPE_EXTERNAL_IMPORT') {
    //     return record;
    //   }
    // });
    // // 去掉外部导入跟进记录
    // groups['PROGRESS_STATUS_LEAD'].filter(record => record.actionType === 'ACTION_TYPE_EXTERNAL_IMPORT');
    // // 组装外部导入的跟进记录
    // let externalImportRecord = "";
    // _.map(externalImportRecordList, record => {
    //   externalImportRecord += record.actionTime + ' ' + record.description + ' ';
    // });
    // // 组装好到外部导入的跟进记录加到 groups['PROGRESS_STATUS_LEAD'] 中
    // groups['PROGRESS_STATUS_LEAD'].add(externalImportRecord);

    // 获取最后一条跟进记录
    const last = _.last(actionRecordList, ["actionTime"])

    return (
      <div className="ActionRecordPanel">
        <Tabs onChange={this.handleChange} value={tabVal}>
          <TabPanel tab="跟进记录" name="record">
            <div className="action-bar">
              <WithPermission reject={!isContain(permissions, fePerms.OUTSIDE_CREATE) || !isContain(permissions, perms.GRAY_IO_MANAGEMENT)}>
                <LinkButton
                  onClick={(e) => {
                    this.goOutside(e, lead, version)
                  }}
                >
                  申请外勤
                </LinkButton>
              </WithPermission>
              {potential && potential.relationship && (
                <WithPermission reject={readOnly} oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL, perms.ORDER_EDIT_SELF, perms.ORDER_EDIT_GROUP, perms.ORDER_EDIT_ALL]}>
                  <Button style={btnStyle} displayType={"primary"} size={"small"} onClick={() => this.showCreateActionRecordModal(true)}>
                    添加批注
                  </Button>
                </WithPermission>
              )}
              <WithPermission reject={!isLead || lead.ownerId !== this.props.currentUserId || !isContain(lead.permissions, fePerms.LEAD_RELEASE)} oneOf={[perms.LEAD_RELEASE_SELF, perms.LEAD_RELEASE_GROUP, perms.LEAD_RELEASE_ANY]}>
                <Button style={btnStyle} displayType={"primary"} size={"small"} onClick={() => this.showReleaseLeadModal(lead)}>
                  释放
                </Button>
              </WithPermission>
              <WithPermission reject={readOnly} oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL, perms.ORDER_EDIT_SELF, perms.ORDER_EDIT_GROUP, perms.ORDER_EDIT_ALL]}>
                {
                  !isLead ? <Button style={btnStyle} displayType={"primary"} size={"small"} onClick={() => this.showPotentialCopyModal(lead)}>
                    复制商机
                  </Button> : null
                }
                <Button displayType={"primary"} size={"small"} onClick={() => this.showCreateActionRecordModal(false)}>
                  添加记录
                </Button>
              </WithPermission>
              <WithPermission reject={!isLead || cleanLeadPerms.indexOf(lead.cleaningStatus) === -1 || !isContain(lead.permissions, fePerms.LEAD_CLEAN)} oneOf={[perms.LEAD_CLEAN_SELF, perms.LEAD_CLEAN_ALL_PENDING]}>
                <Button style={{ marginLeft: "10px" }} displayType={"primary"} size={"small"} onClick={() => this.showClearLeadModal(lead)}>
                  清洗线索
                </Button>
              </WithPermission>
              <WithPermission reject={!isContain(permissions, fePerms.POTENTIAL_OBTAIN)} oneOf={[perms.POTENTIAL_OBTAIN_TO_SELF, perms.POTENTIAL_OBTAIN_TO_GROUP, perms.POTENTIAL_OBTAIN_TO_ANY]}>
                <Button displayType={"primary"} size={"small"} onClick={() => this.showHighSeaPotentialRecordModal()}>
                  添加跟进
                </Button>
              </WithPermission>
              <WithPermission reject={!isContain(lead.permissions, fePerms.LEAD_OBTAIN)} oneOf={[perms.LEAD_OBTAIN_TO_SELF, perms.LEAD_OBTAIN_TO_GROUP, perms.LEAD_OBTAIN_TO_ANY]}>
                <Button displayType={"primary"} size={"small"} onClick={() => this.showHighSeaLeadRecordModal()}>
                  添加跟进
                </Button>
              </WithPermission>
            </div>
            <Table
              className="action-record-table"
              data={_actionRecordList}
            >
              <Column width="80px" name="oldProgressStatus" render={this.renderColumn} autoRowSpan>阶段</Column>
              <Column name="actionTime" render={this.renderColumn}>时间</Column>
              <Column name="actionHandlerId" render={this.renderColumn}>跟进人</Column>
              <Column name="actionType" render={this.renderColumn}>跟进情况</Column>
              <Column name="actionStatus" render={this.renderColumn}>状态变更</Column>
            </Table>
            {/* <table className={"table table-hover table-bordered"}>
              <thead>
                <tr>
                  <th>阶段</th>
                  <th>时间</th>
                  <th>跟进人</th>
                  <th>跟进情况</th>
                  <th>状态变更</th>
                </tr>
              </thead>
              <tbody>
                {this.renderGroup(groups, "PROGRESS_STATUS_ORDER", readOnly, last)}
                {this.renderGroup(groups, "PROGRESS_STATUS_POTENTIAL", readOnly, last)}
                {this.renderGroup(groups, "PROGRESS_STATUS_LEAD", readOnly, last)}
              </tbody>
            </table> */}
          </TabPanel>
          <TabPanel tab="参与活动" name="activity">
            <ActivityList data={activityData} loading={loading} getData={this.fetchActivityListData} getActivityListThis={(obj) => (this.activityList = obj)} />
          </TabPanel>
          <TabPanel tab="修改日志" name="modifylog">
            <ModifyLog data={ModifyLogData} loading={loading} getData={this.fetchModifyLogData} getModifyLogThis={(obj) => (this.modifyLog = obj)} />
          </TabPanel>
          <TabPanel tab="接收内容" name="receiveRecord">
            {tabVal === 'receiveRecord' && <ReceiveRecordPanel leadId={lead.leadId} />}
          </TabPanel>
        </Tabs>

        <Delegate ref={this.createActionRecordModal} component={CreateActionRecordModal} />
        <Delegate ref={this.changePotentialStatusModal} component={ChangePotentialStatusModal} />
        <Delegate ref={this.potentialCopyModal} component={PotentialCopyModal} />
        <Delegate ref={this.audioModal} component={AudioBar} />
        <Delegate ref={this.clearLeadModal} component={CleanLeadModal} />
        <Delegate ref={this.releaseLeadModal} component={ReleaseLeadModal} />
      </div>
    )
  }

  renderUserInfo = (actionRecord) => {
    if (actionRecord.actionType !== "ACTION_TYPE_EXTERNAL_IMPORT") {
      return this.renderComment(actionRecord, <div style={{ minWidth: 80 }}><UserInfo key={actionRecord.actionHandlerId} userId={actionRecord.actionHandlerId} /></div>)
    } else {
      return <div>直销客服</div>
    }
  }

  renderColumn = (type, name, value, data) => {
    if (type === "head") {
      return value
    }
    const { lead, potential, order, version, linkToAccountOpening = false, readOnly } = this.props
    switch(name) {
      case "oldProgressStatus":
        return <ProgressStatus progressStatus={data.oldProgressStatus} />
      case "actionTime":
        return this.renderComment(data, <DateTime dateTime={data.actionTime} />)
      case "actionHandlerId":
        return this.renderUserInfo(data)
      case "actionType":
        return <div>
          {this.renderComment(data, <ActionRecordDescription lead={lead} potential={potential} order={order} actionRecord={data} maxLength={200} linkToAccountOpening={linkToAccountOpening} />)}
          {(data.actionType === "ACTION_TYPE_DIAL_OUT" || data.actionType === "ACTION_TYPE_DIAL_IN") && data.callCenterSessionId && data.talkDuration ? (
            <div className="record-listen enabled" onClick={() => this.handleListen(data)} title="点击播放录音">
              <i className="fas fa-play-circle" />
            </div>
          ) : null}
        </div>
      case "actionStatus":
        const last = _.last(this.state.actionRecordList, ["actionTime"])
        return this.renderStatusChanges(data, !readOnly && data.oldProgressStatus === "PROGRESS_STATUS_POTENTIAL" && data.recordId === last.recordId && this.isChangeable(data))
      default:
        return value
    }

  }

  renderGroup(groups, groupName, readOnly, last) {
    const recordList = groups[groupName]
    if (_.isEmpty(recordList)) {
      return null
    }

    const { lead, potential, order, version, linkToAccountOpening = false } = this.props
    return (
      <React.Fragment>
        {_.map(_.reverse(recordList), (actionRecord, i) => (
          <tr key={`${actionRecord.recordId}${i}`}>
            {i === 0 && (
              <td rowSpan={recordList.length}>
                <ProgressStatus progressStatus={groupName} />
              </td>
            )}
            <td>{this.renderComment(actionRecord, <DateTime dateTime={actionRecord.actionTime} />)}</td>
            {this.renderUserInfo(actionRecord)}
            <td>
              {this.renderComment(actionRecord, <ActionRecordDescription lead={lead} potential={potential} order={order} actionRecord={actionRecord} maxLength={200} linkToAccountOpening={linkToAccountOpening} />)}
              {(actionRecord.actionType === "ACTION_TYPE_DIAL_OUT" || actionRecord.actionType === "ACTION_TYPE_DIAL_IN") && actionRecord.callCenterSessionId && actionRecord.talkDuration ? (
                <span className="record-listen enabled" onClick={() => this.handleListen(actionRecord)} title="点击播放录音">
                  <i className="fas fa-play-circle" />
                </span>
              ) : null}
            </td>
            <td>{this.renderStatusChanges(actionRecord, !readOnly && groupName === "PROGRESS_STATUS_POTENTIAL" && actionRecord === last && this.isChangeable(actionRecord))}</td>
          </tr>
        ))}
      </React.Fragment>
    )
  }

  handleListen = (data) => {
    const { searching } = this.state;

    if (searching) {
      return;
    }

    this.setState({
      searching: true,
    });

    if (data && data.callCenterSessionId) {
      const { webApi } = this.props;
      let request = {};
      request.callCenterSessionId = data.callCenterSessionId;
      request.leadId = data.leadId;
      request.actionHandlerId = data.actionHandlerId;
      if (data.callCenterVendor === CALL_CENTER_VENDOR.CALL_CENTER_VENDOR_QIDIAN.key) {
        // 企点入参增加vendor
        request.vendor = data.callCenterVendor;
      }
      webApi
        .getRecord()
        .ajaxJson({ data: request })
        .then(
          (res) => {
            this.setState({
              searching: false,
            });

            if (res.error) {
              this.context.error("获取录音失败", res.error);
              return;
            }

            this.audioModal.current.show(res);
            // this.audioModal.current.show({ url: res.url });
          },
          (error) => {
            this.setState({
              searching: false,
            })
            this.context.error("获取录音失败", error.message)
          }
        )
    } else {
      this.setState({
        searching: false,
      })
      this.context.error("该通话未接通")
    }
  }

  isChangeable(record) {
    switch (record.actionType) {
      case "ACTION_TYPE_OBTAIN":
      case "ACTION_TYPE_DIAL_OUT":
      case "ACTION_TYPE_DIAL_IN":
      case "ACTION_TYPE_CUSTOMIZE":
        return true
      default:
        return false
    }
  }

  renderStatusChanges(actionRecord, changeable) {
    const {
      potentialId,
      orderId,
      oldVisibilityScope,
      newVisibilityScope,
      oldCleaningStatus,
      newCleaningStatus,
      oldPotentialStatus,
      newPotentialStatus,
      oldTransactionProbability,
      newTransactionProbability,
      oldOrderStatus,
      newOrderStatus,
      oldOwnerId,
      newOwnerId,
      registrationTicketId,
      oldRegistrationTicketStatus,
      newRegistrationTicketStatus,
      actionType,
    } = actionRecord

    // 状态新增驳回原因处理
    if (actionType === "ACTION_TYPE_DISTRIBUTION_OPEN_REJECT") {
      return <span>分配开户人驳回</span>
    }

    if (actionType === "ACTION_TYPE_OPEN_REJECT") {
      return <span>开户驳回</span>
    }

    let oldOwner = undefined
    let newOwner = undefined
    let compareOwner = false

    const changes = []
    if (oldVisibilityScope !== newVisibilityScope) {
      changes.push(getMessage(oldVisibilityScope, "VisibilityScope") + " - " + getMessage(newVisibilityScope, "VisibilityScope"))
    }
    if (oldCleaningStatus !== newCleaningStatus) {
      changes.push(getMessage(oldCleaningStatus, "CleaningStatus") + " - " + getMessage(newCleaningStatus, "CleaningStatus"))
    }
    if (oldOwnerId !== newOwnerId) {
      compareOwner = true
      oldOwner = <UserInfo userId={oldOwnerId} />
      newOwner = <UserInfo userId={newOwnerId} />
    }

    if (potentialId) {
      if (oldPotentialStatus !== newPotentialStatus || oldTransactionProbability !== newTransactionProbability) {
        const oldValue = oldPotentialStatus + "-" + oldTransactionProbability
        const newValue = newPotentialStatus + "-" + newTransactionProbability
        changes.push(getMessage(oldValue, "MixedPotentialStatus") + " - " + getMessage(newValue, "MixedPotentialStatus"))
      }
    }

    // 订单状态变更
    if (orderId) {
      if (oldOrderStatus !== newOrderStatus) {
        const oldValue = oldOrderStatus
        const newValue = newOrderStatus
        changes.push(getMessage(oldValue, "OrderStatus") + " - " + getMessage(newValue, "OrderStatus"))
      }
    }

    // 开户单状态变更
    if (registrationTicketId) {
      if (oldRegistrationTicketStatus !== newRegistrationTicketStatus) {
        const oldValue = oldRegistrationTicketStatus
        const newValue = newRegistrationTicketStatus
        changes.push(getMessage(oldValue, "RegistrationStatus") + " - " + getMessage(newValue, "RegistrationStatus"))
      }
    }

    return this.renderComment(
      actionRecord,
      <span>
        {changes.length === 0 ? "" : changes.join("; ")}
        {compareOwner && oldOwner} - {compareOwner && newOwner}
        {changeable && <LinkButton onClick={() => this.showChangePotentialStatusModal(actionRecord)}>修改</LinkButton>}
      </span>
    )
  }

  showCreateActionRecordModal = (comment = false) => {
    const { webApi, lead, potential, onChange } = this.props
    this.createActionRecordModal.current.show({
      webApi,
      lead,
      potential,
      comment,
      onSubmit: (...args) => {
        this.fetchActionRecordList(comment ? '添加批注' : '添加记录');
        onChange && onChange()
      },
    })
  }

  /**
   * @description: 公海商机添加跟进记录
   */
  showHighSeaPotentialRecordModal = () => {
    const { potential, onChange } = this.props
    this.createActionRecordModal.current.show({
      lead: potential.lead,
      claimParams: {
        potentials: [{
          leadId: potential.leadId,
          version: potential.version,
        }],
      },
      claimWebApiName: "obtainPotentials",
      claimShow: isContain(potential.permissions, fePerms.POTENTIAL_OBTAIN),
      onSubmit: () => {
        this.fetchActionRecordList('公海商机添加跟进记录')
        onChange && onChange()
      },
    })
  }

  /**
   * @description: 公海线索添加跟进记录
   */
  showHighSeaLeadRecordModal = () => {
    const { lead, onChange } = this.props
    this.createActionRecordModal.current.show({
      lead,
      claimParams: {
        leads: [{
          leadId: lead.leadId,
          version: lead.version,
        }],
      },
      claimWebApiName: "obtainLead",
      claimShow: isContain(lead.permissions, fePerms.LEAD_OBTAIN),
      onSubmit: () => {
        this.fetchActionRecordList('公海线索添加跟进记录')
        onChange && onChange()
      },
    })
  }

  /**
   * @description: 复制商机
   */
  showPotentialCopyModal = (lead) => {
    this.potentialCopyModal.current.show({
      lead,
    })
    refreshStatisticOnDetail({ data: this.props.isLead ? this.props.lead : this.props.potential, actionName: '复制商机' });
  }

  goOutside = (e, data, version) => {
    const { history } = this.props
    const leadIdCompanyName = data.leadId + " - " + data.company.companyName + " : " + version
    history.push({ pathname: "/outside/create-from-potential/" + leadIdCompanyName })
    refreshStatisticOnDetail({ data: this.props.isLead ? this.props.lead : this.props.potential, actionName: '申请外勤' });
  }

  showChangePotentialStatusModal = (actionRecord) => {
    const { webApi, lead, potential, onChange } = this.props
    this.changePotentialStatusModal.current.show({
      webApi,
      lead,
      potential,
      actionRecord,
      onSubmit: (...args) => {
        this.fetchActionRecordList()
        onChange && onChange()
      },
    })
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
    cleanReasonConfig: state.cleanReasonConfig,
    currentUserId: state.loginStatus.userId,
  }
}

export default withApi(withRouter(connect(mapStateToProps)(ActionRecordPanel)))

ActionRecordPanel.contextType = MessageBox
